import Web3 from "web3";
import FractionalTokenABI from "../contracts/abi/FractionalToken";
import ERC721ABI from "./../contracts/abi/ERC721";
import NFTLockABI from "./../contracts/abi/NFTLock";
const NFTLOCK_ADDRESS = "0x87a6dE1B06fDDb000618aFca237178228D6E6143";
const SIMPLENFT_ADDRESS = "0x48Ffd4d8C362bADb4233B0055Ab8D26a2aaCF19f";
export const handleApprove = async (contractAddress, tokenId, from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(ERC721ABI, contractAddress);
  const receipt = await contractInstance.methods
    .approve(NFTLOCK_ADDRESS, tokenId)
    .send({ from });
  console.log(receipt);
};

export const fetchWhitelisted = async (from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const numberOfTokens =
    await contractInstance.methods.FXNTokenNonce.call().call();
  let whitelistedTokens = [];
  for (let nonce = 0; nonce < numberOfTokens; nonce++) {
    const token = await contractInstance.methods
      ._whitelistedTokens(nonce)
      .call();
    const tokenContractInstance = new web3.eth.Contract(
      ERC721ABI,
      token.tokenAddress
    );
    const tokenURI = await tokenContractInstance.methods
      .tokenURI(token.tokenId)
      .call();
    const operator = await tokenContractInstance.methods
      .getApproved(token.tokenId)
      .call();
    const parsedToken = parseWhitelistOutput(token, tokenURI, nonce, operator);
    if (parsedToken.owner === from) whitelistedTokens.push(parsedToken);
  }
  return whitelistedTokens;
};

export const getAllTokens = async () => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const numberOfTokens =
    await contractInstance.methods.FXNTokenNonce.call().call();
  let whitelistedTokens = [];
  for (let nonce = 0; nonce < numberOfTokens; nonce++) {
    const token = await contractInstance.methods
      ._whitelistedTokens(nonce)
      .call();
    const tokenContractInstance = new web3.eth.Contract(
      ERC721ABI,
      token.tokenAddress
    );
    const tokenURI = await tokenContractInstance.methods
      .tokenURI(token.tokenId)
      .call();
    const operator = await tokenContractInstance.methods
      .getApproved(token.tokenId)
      .call();
    console.log(token);
    const parsedToken = parseWhitelistOutput(token, tokenURI, nonce, operator);
    if (token.status == 1||token.status == 2) whitelistedTokens.push(parsedToken);
  }
  return whitelistedTokens;
};

export const fractionalise = async (
  tokenAddress,
  tokenId,
  name,
  symbol,
  nonce,
  from,
  value
) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const receipt = await contractInstance.methods
    .fractionalise(tokenAddress, tokenId, name, symbol, nonce)
    .send({ from });
  console.log(receipt);
  return receipt;
};

export const buyFraction = async (tokenAddress, value, from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(
    FractionalTokenABI,
    tokenAddress
  );
  const receipt = await contractInstance.methods.mint().send({ from, value });
  return receipt;
};
export const sellFraction = async (tokenAddress, amount, from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(
    FractionalTokenABI,
    tokenAddress
  );
  const receipt = await contractInstance.methods
    .burn(amount)
    .send({ from });
  return receipt;
};
export const balanceOf = async (tokenAddress, from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(
    FractionalTokenABI,
    tokenAddress
  );
  const balance = await contractInstance.methods.balanceOf(from).call();
  return balance;
};
export const getTokenDetails = async (tokenAddress, from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(
    FractionalTokenABI,
    tokenAddress
  );
  const name = await contractInstance.methods.name.call().call();
  const symbol = await contractInstance.methods.symbol.call().call();
  const supply = await contractInstance.methods.totalSupply().call();
  const reserveBalance = await contractInstance.methods.reserveBalance
    .call()
    .call();
  return { name, symbol, supply, reserveBalance };
};
export const getEthBalance = async (from) => {
  const web3 = new Web3(window.ethereum);
  const balance = await web3.eth.getBalance(from);
  return balance;
};
export const mintToken = async (tokenURI, from) => {
  const web3 = new Web3(window.ethereum);
  const contractInstance = new web3.eth.Contract(ERC721ABI, SIMPLENFT_ADDRESS);
  const receipt = await contractInstance.methods
    .createCollectible(tokenURI)
    .send({ from });
  return receipt;
};
export const whitelistToken = async (from) => {
  const web3 = new Web3(window.ethereum);
  const NFTcontract = new web3.eth.Contract(ERC721ABI, SIMPLENFT_ADDRESS);
  const tokenCount = await NFTcontract.methods.tokenCounter.call().call();
  const contractInstance = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const receipt = await contractInstance.methods
    .whitelistToken(SIMPLENFT_ADDRESS, tokenCount - 1)
    .send({ from });
  return receipt;
};
export const initiateBuyout = async (nonce, from) => {
  const web3 = new Web3(window.ethereum);
  const NFTcontract = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const receipt = await NFTcontract.methods.initiateBuyout(nonce).send({
    from,
  });
  console.log(receipt);
  return receipt;
};
export const unlock = async (nonce, from) => {
  const web3 = new Web3(window.ethereum);
  const NFTcontract = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  //TODO modify the contract to only take nonce
  const receipt = await NFTcontract.methods.unlock(from, nonce).send({
    from,
  });
  console.log(receipt);
  return receipt;
};

export const cancelBuyout = async (nonce, from) => {
  const web3 = new Web3(window.ethereum);
  const NFTcontract = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const receipt = await NFTcontract.methods.cancelBuyout(nonce).send({ from });
  return receipt;
};
export const getWinner = async (nonce, from) => {
  const web3 = new Web3(window.ethereum);
  const NFTcontract = new web3.eth.Contract(NFTLockABI, NFTLOCK_ADDRESS);
  const receipt = await NFTcontract.methods.winner(nonce).call({ from });
  return receipt;
};

function parseWhitelistOutput(token, imageUrl, nonce, operator) {
  const { tokenId, tokenAddress, owner, status, fxnAddress } = token;
  let isApproved = false;
  if (operator == NFTLOCK_ADDRESS) {
    isApproved = true;
  }
  return {
    tokenId,
    tokenAddress,
    owner,
    status,
    imageUrl,
    isApproved,
    nonce,
    fxnAddress,
  };
}
